import { GETFREELANCEBUILDREQUIREMENT } from "../../../ENVIRONMENT";

// api for freelance client build requirement inforamtion
async function freegetRequirementInfo(token, id) {
  const response = await fetch(GETFREELANCEBUILDREQUIREMENT + `/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { freegetRequirementInfo };
